import { useDispatch, useSelector } from "react-redux";
/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";

// react-router components
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { LinearProgress } from "@material-ui/core";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Dashboard 2 React components

// Material Dashboard 2 React example components
import Sidenav from "views/Sidenav";

// Material Dashboard 2 React themes
import theme from "assets/theme";

// Material Dashboard 2 React Dark Mode themes
import themeDark from "assets/theme-dark";

// Material Dashboard 2 React routes
import routes from "routes";

// Material Dashboard 2 React contexts
import { setMiniSidenav, useMaterialUIController } from "context";

// Images
import brandWhite from "assets/images/logo-ct.png";
import brandDark from "assets/images/logo-ct-dark.png";
import { useMeQuery } from "./store/api/auth";
import { authActions } from "./store/auth/auth-slice";

import Index from "./layouts/Index";
import { getRouteActionType } from "./helpers/constants/constraints";
import Settings from "./layouts/pages/account/settings";

function App() {
  //const user = useSelector((state) => state.auth.user);
  const { data: user } = useMeQuery();
  const { enqueueSnackbar } = useSnackbar();

  const notification = useSelector((state) => state.notification.notification);

  const dispatchUser = useDispatch();
  const isLoading = useSelector((state) => state.notification.isLoading);
  const { data } = useMeQuery();
  useEffect(() => {
    if (notification) {
      enqueueSnackbar(notification.message, {
        variant: notification.variant,
        anchorOrigin: {
          vertical: notification.vertical,
          horizontal: notification.horizontal,
        },
      });
    }
  }, [notification, enqueueSnackbar]);

  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>{
    return allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route && getRouteActionType(user, route.access_type)) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });
  }
  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      {isLoading && <LinearProgress color="secondary" />}
      <CssBaseline />
      {layout === "dashboard" && (
        <Sidenav
          color={sidenavColor}
          brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
          brandName="EventPix Web"
          routes={routes.filter(e => e.sidebar.visible === true)}
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
        />
      )}
      <Routes>
        {getRoutes(routes)}
        <Route exact path="/" element={<Index />} />
        {/*<Route exact path="/profile"     element={<Settings />}  />;*/}

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
